import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button, Col, Divider, Flex, Row,
} from 'antd';
import clsx from 'clsx';

import { type BuilderUiProps } from '../AutomationsCriteriaConditionsWrapper/AutomationsCriteriaConditionsWrapper';
import styles from './ShowConditionsUi.module.scss';

export default function ShowConditionsUi({
  setBuilderOpen,
  handleDelete,
  selectedFiltersUi,
  appliedFilters,
  title,
  btnClassName,
}: BuilderUiProps & { title: string, btnClassName?: string }) {
  if (appliedFilters?.levels?.length) {
    return (
      <Row className={styles.conditionUiContainer}>
        <Col className={styles.filterContainer} span={16}>
          {selectedFiltersUi}
        </Col>
        <Flex align="center">
          <Button
            onClick={() => setBuilderOpen(true)}
            size="small"
            type="link"
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Divider type="vertical" />
          {/* todo: fix this */}
          <Button
            onClick={handleDelete}
            size="small"
            type="link"
            icon={<DeleteOutlined />}
            danger
          >
            Remove
          </Button>
        </Flex>
      </Row>
    );
  } else {
    return (
      <Button
        onClick={() => setBuilderOpen(true)}
        icon={<PlusOutlined />}
        type="dashed"
        className={clsx(styles.additionalBtn, btnClassName)}
      >
        {title}
      </Button>
    );
  }
}
